<template>
  <div id="mains">
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="12">
            <div class="head_left Font_size_24">
              <!--<img src="../../static/img/logo.png" />-->{{ SystemTitle }}
            </div>
          </el-col>
          <el-col :span="12">
            <div class="head_right pull-right">
              <div class="off_box pull-right" @click="logout">
                <img
                  src="../../static/img/off.png"
                  title="退出系统"
                  width="24"
                />
              </div>
              <div class="loginName pull-right">
                <div class="user_img">
                  <span style>{{ user.StationName || user.GroupName }}</span>
                  <span
                    style="color: greenyellow"
                    v-if="!showAllUserRoleNames"
                    >{{ user.RolesName.split(",")[0] }}</span
                  ><span
                    v-if="
                      !showAllUserRoleNames &&
                      user.RolesName &&
                      user.RolesName.split(',').length > 1
                    "
                  >
                    <i
                      class="fa fa-chevron-right"
                      v-on:click="setShowRoleNames"
                      title="展开角色"
                      style="cursor: default"
                    ></i>
                  </span>
                  <span
                    style="color: greenyellow"
                    v-if="showAllUserRoleNames"
                    >{{ user.RolesName }}</span
                  ><span
                    v-if="
                      showAllUserRoleNames &&
                      user.RolesName &&
                      user.RolesName.split(',').length > 1
                    "
                  >
                    <i
                      class="fa fa-chevron-left"
                      v-on:click="setShowRoleNames"
                      title="收缩角色"
                      style="cursor: default"
                    ></i>
                  </span>
                  <span style>{{ user.NickName }}</span>
                </div>
              </div>
              <!--<div class="head_icon pull-right" v-bind:class="{icon_active:icon_active(1)}">
                <el-dropdown
                  trigger="click"
                  :hide-on-click="false"
                  placement="bottom-start"
                  @visible-change="active(1)"
                >
                  <span class="el-dropdown-link">
                    <i class="fa fa-book"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-tickets">关于我们</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-document" divided>帮助中心</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="head_icon pull-right" v-bind:class="{icon_active:icon_active(2)}">
                <el-dropdown
                  trigger="click"
                  :hide-on-click="false"
                  placement="bottom-start"
                  @visible-change="active(2)"
                >
                  <el-badge is-dot class="item" style="margin-top：-10px;">
                    <span class="el-dropdown-link">
                      <i class="fa fa-bell-o"></i>
                    </span>
                  </el-badge>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>最新放假通知...</el-dropdown-item>
                    <el-dropdown-item divided>内部公告</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>-->
              <span>
                <i
                  v-if="showAllToolMenu"
                  class="fa fa-chevron-right"
                  v-on:click="setShowToolMenu"
                  title="收缩菜单"
                  style="cursor: default"
                ></i>
                <i
                  v-else
                  class="fa fa-chevron-left"
                  v-on:click="setShowToolMenu"
                  title="展开菜单"
                  style="cursor: default"
                ></i>
              </span>
              <div class="head_icon pull-right">
                <i
                  class="el-icon-info"
                  v-on:click="showabout"
                  title="关于我们"
                  style="cursor: default"
                ></i>
              </div>
              <div class="head_icon pull-right">
                <i
                  class="fa fa-user-circle"
                  v-on:click="showUser"
                  title="个人信息"
                  style="cursor: default"
                ></i>
              </div>
              <div class="head_icon pull-right">
                <i
                  class="fa fa-unlock-alt"
                  v-on:click="togglepassword"
                  title="修改密码"
                  style="cursor: pointer"
                ></i>
              </div>
              <div class="head_icon pull-right" v-if="showAllToolMenu">
                <i
                  class="fa fa-weixin"
                  v-on:click="bindWeChat"
                  title="绑定微信"
                  style="cursor: pointer"
                ></i>
              </div>
              <div class="head_icon pull-right" v-if="showAllToolMenu">
                <i
                  v-bind:class="className"
                  v-on:click="toggleNav"
                  :title="isCollapse ? '展开菜单' : '折叠菜单'"
                  style="cursor: pointer"
                ></i>
              </div>
              <div
                class="head_icon pull-right"
                v-if="ShowFullIcon && showAllToolMenu"
              >
                <i
                  :class="isfullscreen ? 'fa fa-compress' : 'fa fa-expand'"
                  v-on:click="toggleFullScreen"
                  :title="isfullscreen ? '退出全屏' : '全屏显示'"
                  style="cursor: pointer"
                ></i>
              </div>
              <div class="head_icon pull-right" v-if="showAllToolMenu">
                <i
                  :class="isUsingTab ? 'el-icon-open' : 'el-icon-turn-off'"
                  v-on:click="changeTabStatus"
                  :title="isUsingTab ? '关闭Tab' : '开启Tab'"
                  style="cursor: pointer"
                ></i>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container class="main">
        <el-aside
          id="main"
          :class="isCollapse ? 'menu-collapsed' : 'menu-expanded'"
          style="overflow-x: hidden"
        >
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            :collapse="isCollapse"
            :unique-opened="true"
            router
          >
            <template v-for="(item, index) in $router.options.routes">
              <template>
                <!-- 如果有子列表，就渲染；404等页面没有子孩子，所以可以根据这个筛选掉404等页面。 -->
                <template
                  v-if="
                    item.children != undefined &&
                    item.children.length > 0 &&
                    !item.hidden &&
                    !item.IsNotNavigation
                  "
                >
                  <!-- 如果有2个以上的子菜单，就合并成el-submenu -->
                  <template v-if="item.children.length > 1">
                    <el-submenu :key="index" :index="index + ''">
                      <template slot="title">
                        <i :class="item.iconCls"></i>
                        <span slot="title">{{ item.name }}</span>
                      </template>

                      <template v-for="(child, subindex) in item.children">
                        <!-- 再查找一层子路由，如果有，就合并成el-submenu -->
                        <el-submenu
                          v-if="child.children && child.children.length > 0"
                          :index="index + '-' + subindex"
                          :key="index + '-' + subindex"
                        >
                          <template slot="title">
                            <span class="sub_padding_left">{{
                              child.name
                            }}</span>
                          </template>
                          <el-menu-item
                            v-for="ccchild in child.children"
                            :index="ccchild.path"
                            :key="ccchild.path"
                          >
                            <span class="sub_padding_left">{{
                              ccchild.name
                            }}</span>
                          </el-menu-item>
                        </el-submenu>

                        <!-- 如果没有子孩子了，就渲染成el-menu-item，由于组件开启了router模式，所以index必须是path  -->
                        <el-menu-item
                          v-else-if="!child.hidden"
                          :index="child.path"
                          :key="child.path"
                        >
                          <span class="sub_padding_left">{{ child.name }}</span>
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>

                  <!-- 如果只有一个子菜单，就不用合并。 -->
                  <template v-else>
                    <el-menu-item :key="item.path" :index="item.path">
                      <i :class="item.iconCls"></i>
                      <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                  </template>
                </template>
              </template>
            </template>
          </el-menu>

          <!-- <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            :collapse="isCollapse"
            :unique-opened="true"
            router
          >
            <template v-for="(item,index) in $router.options.routes">
              <template v-if="index==0">
                <template v-for="child in item.children">
                  <el-menu-item :key="child.path" :index="child.path">
                    <i :class="item.iconCls"></i>
                    <span slot="title">{{item.name}}</span>
                  </el-menu-item>
                </template>
              </template>
              <template v-else>
                <el-submenu
                  :key="index"
                  :index="index+''"
                  v-if="item.children!=undefined && item.children.length>0 && !item.hidden"
                >
                  <template slot="title">
                    <i :class="item.iconCls"></i>
                    <span slot="title">{{item.name}}</span>
                  </template>
                  <template v-for="(child,subindex) in item.children">
                    <el-submenu
                      v-if="child.children && child.children.length>0"
                      :index="index+'-'+subindex"
                      :key="index+'-'+subindex"
                    >
                      <template slot="title">
                        <span class="sub_padding_left">{{child.name}}</span>
                      </template>
                      <el-menu-item
                        v-for="ccchild in child.children"
                        :index="ccchild.path"
                        :key="ccchild.path"
                      >
                        <span class="sub_padding_left">{{ccchild.name}}</span>
                      </el-menu-item>
                    </el-submenu>
                    <el-menu-item v-else-if="!child.hidden" :index="child.path" :key="child.path">
                      <span class="sub_padding_left">{{child.name}}</span>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </template>
          </el-menu>-->
        </el-aside>

        <el-container style="width: 100%">
          <el-main>
            <router-tab restore v-if="isUsingTab"></router-tab>
            <!-- <keep-alive :include="welcome / welcome"> -->
            <router-view
              v-if="!isUsingTab"
              class="container-box-samll"
            ></router-view>
            <!-- </keep-alive> -->
          </el-main>
          <el-footer>
            <p class="text-right">Copyright © 2021</p>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
    <!--添加关于我们-->
    <!--<about
      v-bind:AboutShow="addabout"
      v-on:AboutShow="updateaddabout()"
    ></about>-->
    <!--添加弹出框-->
    <UserDialog
      v-bind:dialogTitle="dialogTitle"
      v-bind:dialogVisible="showUserDialog"
      v-on:dialogClose="dialogClose($event)"
    ></UserDialog>
  </div>
</template>

<script>
import { truncate, constants } from "fs";
import { connect } from "net";
import { setInterval } from "timers";
import fscreen from "fscreen";
//import about from "../components/child/abouts";
import { request } from "https";
import { getWebSocketUrl } from "@/js/globalConfig.js";
import UserDialog from "./permission/user/userInfo";
import { time } from "console";
let vmthis = this;
var mySocket = null;
var timer = null;
var timerList = [];
//第一次加载页面时读取配置文件到store中
// import globalConfig from '@/js/globalConfig.js'
// import modiPassword from "../components/permission/user/modiPassword";
export default {
  name: "mains",
  data() {
    return {
      socket: null,
      tabs: [{ closable: false }],
      SystemTitle: "燕通检车平台",
      isUsingTab: true, //是否开启Tab页功能
      intervalId: null,
      addabout: false,
      isCollapse: false,
      tabPosition: "left",
      isacvite: -1,
      timeOut: 14400, //30分钟无操作 跳转到登录界面 2020-11-30改为4小时
      timesTamp: 0,
      user: null,
      UserCode: null,
      version: "v0.9.1@alpha",
      isfullscreen: false,
      showUserDialog: false,
      dialogTitle: "用户信息",
      showAllUserRoleNames: false, //是否显示所有用户角色名称
      showAllToolMenu: false, //是否显示工具菜单
    };
  },
  beforeMount: function () {
    //初始化$router
    var grants = "";
    let btnArr = this.$store.getters["user/UserInfo"].UserGrants || [];
    for (let i = 0; i < btnArr.length; i++) {
      grants += "|" + btnArr[i].GrantCode;
    }

    grants += "|";

    this.$router.options.routes.forEach((element) => {
      if (element.meta != undefined && element.meta != null) {
        if (element.meta.code != undefined && element.meta.code != null) {
          //检查一级菜单
          var authCode = "|" + element.meta.code + "|";
          //只判断显示项是否就有权限
          if (element.hidden == false) {
            //权限编码在的情况下也根据hidden显示
            if (grants.indexOf(authCode) > -1 && !element.hidden) {
              element.hidden = false;
            } else {
              element.hidden = true;
            }
          }
          // if ((element.isHidden = true)) {
          //   element.hidden = true;
          // } else {
          // }
          //检查二级菜单
          var children = element.children;
          if (children) {
            for (var i = 0; i < children.length; i++) {
              if (
                children[i].meta.code != undefined &&
                children[i].meta.code != null
              ) {
                var childCode = "|" + children[i].meta.code + "|";
                //检查非隐藏项，若有权限，则显示，否则隐藏
                if (children[i].hidden == false) {
                  if (grants.indexOf(childCode) > -1) {
                    children[i].hidden = false;
                  } else {
                    children[i].hidden = true;
                  }
                }
              }
            }
          }
        }
      }
    });
  },
  created() {
    //这里await会导致user报错
    // getWebSocketUrl();
    // var WebSocketPromise = new Promise((resolve, reject) => {
    //   getWebSocketUrl().then();
    //   console.log(this.$store.state.globalConfig.WebSocketUrl);
    //   resolve();
    // });
    //获取用户信息
    this.user = this.$store.getters["user/UserInfo"];
    // console.log("用户信息");
    // console.log(this.user);
    this.UserCode = this.user.UserCode;
    if (this.user.UserType == 0) {
      this.SystemTitle = this.SystemTitle + "-平台版";
    } else if (this.user.UserType == 1) {
      this.SystemTitle = this.SystemTitle + "-集团版";
    } else if (this.user.UserType == 2) {
      this.SystemTitle = this.SystemTitle + "-机构版";
    } else {
      this.SystemTitle = this.SystemTitle;
    }
    window.addEventListener("beforeunload", (e) => {
      window.name = "";
    });

    if (this.socket) {
      this.socket.close(); // 关闭websocket
    }
    // 连接webSocket，用于接收后台实时信息推送
    if (window.name == "") {
      var that = this;
      getWebSocketUrl().then(() => {
        //console.info(that.$store.getters["globalConfig/WebSocketUrl"]);
        that.webSocket();
      });
    }
    if (window.name == "") {
      // 在首次进入页面时我们给window.name设置一个固定值(isRefresh)
      window.name = "refresh";
    } else if (window.name == "refresh") {
    }
  },
  mounted: function () {
    if (!this.f_IsFullScreen()) {
      try {
        var wscript = new ActiveXObject("WScript.Shell");

        wscript.SendKeys("{F11}");

        //this.isfullscreen = true;
      } catch (e) {}
    }

    var vm = this;

    var overtime = vm.$store.getters["user/UserInfo"].OverTime;

    if (overtime > 0) {
      this.timeOut = overtime * 60;
    } else {
      this.timeOut = 86400;
    }
    //console.log(this.timeOut);
    //this.$router.push({ path: "/page/right" });
    window.addEventListener("mousemove", function (e) {
      vm.timesTamp = 0;
    });

    vm.intervalId = setInterval(function () {
      if (vm.timesTamp > vm.timeOut) {
        if (vm.intervalId == null) {
          return;
        }
        //console.log(vm.intervalId);
        clearInterval(vm.intervalId);
        vm.$alert("登录超时，请重新登录！", "登录超时");
        vm.$store.dispatch("user/removetoken");
        vm.$router.replace("/login");
      }
      vm.timesTamp += 5;
    }, 5000);
  },
  beforeDestroy: function () {
    clearInterval(this.intervalId);
    this.intervalId = null;
    window.name = "";
    this.intervalEnd();
    mySocket.close();
  },
  destroyed() {
    //页面销毁时关闭ws连接
    // if (this.socket) {
    //   this.socket.close(); // 关闭websocket
    // }
  },
  methods: {
    intervalEnd() {
      if (timer) {
        timerList.forEach((item, index) => {
          clearInterval(item);
        });
        timerList = [];
        timer = null;
      }
    },
    webSocket() {
      if (typeof WebSocket == "undefined") {
        this.$notify({
          title: "提示",
          message: "当前浏览器无法接收实时报警信息，请使用谷歌浏览器！",
          type: "warning",
          position: "bottom-right",
          duration: 0,
        });
      } else {
        let that = this;
        // if (timer) {
        //   clearInterval(timer);
        // } else {
        // }
        if (mySocket != null) {
          mySocket = null;
        }
        // 获取token保存到vuex中的用户信息，此处仅适用于本项目，注意删除或修改
        // console.info(userInfo);
        // 实例化socket，这里我把用户名传给了后台，使后台能判断要把消息发给哪个用户，其实也可以后台直接获取用户IP来判断并推送
        //const socketUrl = "ws://10.14.7.13:9008";
        //console.info(this.$store.getters["globalConfig/WebSocketUrl"]);
        //console.info(this.$store.state.globalConfig.WebSocketUrl);
        //const socketUrl = this.$store.getters["globalConfig/WebSocketUrl"];
        const socketUrl = "ws://127.0.0.1:9008";
        //const socketUrl = "ws://10.14.7.13:9008";
        //const socketUrl = "ws://127.0.0.1:9008";
        // const socketUrl = "ws://10.14.7.24:9008";
        // this.socket = new WebSocket(socketUrl);
        mySocket = new WebSocket(socketUrl);
        // 监听socket打开
        mySocket.onopen = () => {
          console.log("浏览器WebSocket已打开");
          console.log(Date());
          mySocket.send("$$$" + this.UserCode);
          this.intervalEnd();
          if (timer == null) {
            timer = window.setInterval(() => {
              try {
                if (mySocket.readyState == mySocket.CLOSED) {
                  console.info(mySocket.readyState);
                  console.info("断开了" + Date());
                }
                if (mySocket.readyState != mySocket.OPEN) {
                } else {
                  mySocket.send("test");
                }
              } catch (err) {
                console.info(mySocket.readyState);
                console.log("断开了：");
                console.log(Date());
              }
            }, 10000);
            console.info(timer);
            timerList.push(timer);
          }
        };
        // 监听socket消息接收
        mySocket.onmessage = function (msg) {
          // 转换为json对象
          const data = JSON.parse(msg.data);
          that.$notify({
            title: data.MessageTitle,
            message: data.Message,
            type: data.MessageType,
            duration: 0,
            offset: 50,
            position: "bottom-right",
            onClick: () => {
              that.$router.push(data.Url);
            },
          });
        };
        // 监听socket错误
        mySocket.onerror = function () {
          // that.$notify({
          //   title: "错误",
          //   message: "服务器错误，无法接收实时报警信息，请刷新页面尝试重连",
          //   type: "error",
          //   position: "bottom-right",
          //   duration: 0,
          //   offset: 50
          // });
          // that.$notify({
          //   title: "消息提示服务连接关闭",
          //   message: "消息提示服务连接关闭，请点击尝试重连",
          //   type: "error",
          //   position: "bottom-right",
          //   duration: 0,
          //   offset: 50,
          //   showClose: false,
          //   onClick: () => {
          //     that.$router.go(0);
          //   },
          // });
        };
        // 监听socket关闭
        mySocket.onclose = (e) => {
          console.log("WebSocket已关闭");
          console.log(Date());
          console.log(
            "websocket 断开: " + e.code + " " + e.reason + " " + e.wasClean
          );
          console.log(e);
          if (window.name != "") {
            this.webSocket();
          }
          // that.$notify({
          //   title: "连接关闭",
          //   message: "消息提示连接关闭，请点击尝试重连",
          //   type: "error",
          //   position: "bottom-right",
          //   duration: 0,
          //   offset: 50,
          //   showClose: false,
          //   onClick: () => {
          //     that.$router.go(0);
          //   },
          // });
          // clearInterval(that.timer);
        };
      }
    },
    //添加弹出框
    showabout: function () {
      this.addabout = true;
    },
    updateaddabout(Taboutshow) {
      this.addabout = Taboutshow;
    },
    showUser: function () {
      this.showUserDialog = true;
    },
    dialogClose(visible) {
      this.showUserDialog = visible;
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    toggleNav() {
      this.isCollapse = !this.isCollapse;
      console.log(this.isCollapse);
      // alert("toggleNav");
      //this.$router.push("/Permission/ModiPassword");
    },
    togglepassword() {
      //this.isCollapse = !this.isCollapse;
      // alert("toggleNav");
      this.$router.push("/permission/modiPassword");
    },
    bindWeChat() {
      this.$router.push("/permission/bindWeChat");
    },
    active(num) {
      this.isacvite = num;
    },
    icon_active(num) {
      if (this.isacvite == num) {
        return true;
      } else {
        return false;
      }
    },
    logout() {
      var that = this;
      document.onkeydown = function (e) {};
      var bh = this.$store.getters["user/UserInfo"].UserName;
      this.logoutSubmit(bh);
      this.$store.dispatch("user/removetoken");
      this.$store.dispatch("user/removeuser");
      this.$store.dispatch("dropDown/removeAll");
      this.$store.dispatch("permission/removeRouterList");
      this.$router.push({ path: "/login" });
      //登出时将websocket连接关闭
      window.name = "";
      mySocket.close();
      //localStorage.clear();
    },
    f_IsFullScreen() {
      var oHeight =
        document.body.clientHeight == 0
          ? document.documentElement.clientHeight
          : document.body.clientHeight;
      // console.log(oHeight);
      return (
        oHeight + 1 >= window.screen.height &&
        document.documentElement.clientWidth >= window.screen.width
      );
    },
    logoutSubmit(bh) {
      this.$axios
        .post(
          "/Login/LoginOut",
          { LoginName: bh },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then(
          function (res) {
            if (res.data.Code == "10000") {
            }
          }.bind(this)
        ) //bind(this)可以不用
        .catch(
          function (err) {
            if (err.response) {
              console.log("服务端错误，登出失败！");
            }
          }.bind(this)
        ); //bind(this)可以不用
    },
    toggleFullScreen() {
      if (fscreen.fullscreenEnabled) {
        if (!fscreen.fullscreenElement) {
          this.isfullscreen = true;
          fscreen.requestFullscreen(document.documentElement);
        } else {
          this.isfullscreen = false;
          fscreen.exitFullscreen();
        }
      }
    },
    changeTabStatus() {
      this.isUsingTab = !this.isUsingTab;
    },
    setShowRoleNames() {
      this.showAllUserRoleNames = !this.showAllUserRoleNames;
    },
    setShowToolMenu() {
      this.showAllToolMenu = !this.showAllToolMenu;
      console.log(this.showAllToolMenu);
    },
  },
  computed: {
    className() {
      return this.isCollapse ? "fa fa-indent" : "fa fa-outdent";
    },
    ShowFullIcon() {
      if (
        (window.navigator.userAgent.indexOf("compatible") > -1 &&
          window.navigator.userAgent.indexOf("MSIE") > -1) ||
        (window.navigator.userAgent.indexOf("Trident") > -1 &&
          window.navigator.userAgent.indexOf("rv:11.0") > -1)
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {
    UserDialog: UserDialog,
    // modiPassword: modiPassword
  },
};
</script>

<style>
.menu-collapsed {
  width: 64px !important;
  transition-property: width;
  transition-duration: 320ms;
}
.menu-expanded {
  width: 228px !important;
  transition-property: width;
  transition-duration: 620ms;
}
.el-badge__content.is-fixed {
  top: 20px;
}
.el-badge__content.is-fixed.is-dot {
  right: 12px;
}
.el-popper[x-placement^="bottom"] {
  margin-top: -2px;
  margin-left: -10px;
}
.el-tabs--left .el-tabs__header.is-left {
  padding: 12px 12px 12px 10px;
  background: #f8f9fc;
}
.el-tabs--border-card {
  border: 0;
}
/*一级菜单*/
.menubox_left {
  width: 60px;
  float: left;
}
.sub_padding_left {
  padding-left: 28px;
}
body {
  height: 100%;
  min-width: 1366px;
}
#main {
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  position: absolute;
  position: fixed;
}
.el-header {
  background: -webkit-repeating-linear-gradient(left, #5170ed, #4265ed);
  background: -moz-repeating-linear-gradient(left, #5170ed, #4265ed);
  background: repeating-linear-gradient(left, #5170ed, #4265ed);
  background: #4265ed;
  color: #fff;
  line-height: 60px;
  height: 68px;
  top: 0;
}

.head_left img {
  float: left;
  margin-top: 8px;
  margin-right: 14px;
}
.off_box {
  background: #2f55ed;
  width: 60px;
  padding-top: 6px;
  float: right;
  text-align: center;
}
.user_img {
  padding: 0 16px 0 10px;
  /* background: url("../../static/img/top_line.png") no-repeat left; */
  margin-left: 6px;
}
.user_img img {
  float: left;
  margin-top: 10px;
  margin-right: 6px;
}
.head_icon {
  padding: 0 10px;
  font-size: 1.3em;
}
.icon_active {
  background: #3b5dd8;
}
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  font-size: 1.4em;
}
.sub_title {
  height: 52px;
  line-height: 52px;
  border-bottom: 1px solid #eaebec;
  text-indent: 18px;
}
.el_menu_padding_left {
  padding-left: 20px;
}
/*****底部*******/
.el-footer {
  background-color: #f3f5f9;
  color: #333;
  line-height: 42px;
  height: 40px !important;
  bottom: 0;
  z-index: 22;
  font-size: 14px;
}

.main {
  display: flex;
  top: 60px;
  bottom: 0px;
  overflow: hidden;
  position: absolute;
  width: 100%;
  background-color: #fff;
}
.el-aside {
  color: #333;
  text-align: left;
  flex: 0 0 0 228px;
  width: 228px;
  overflow-x: hidden;
  border-right: 1px solid #eaebec;
}

.el-main {
  color: #333;
  text-align: left;
  flex: 1;
  overflow-y: auto;
  /* padding: 12px 12px 0 12px; */
  padding: 6px 12px 0 12px;
  background-color: #f3f5f9;
  border-left: 0px solid #eaebec;
}
</style>
<style lang="scss">
// 覆盖router-tab框架样式
.router-tab__container {
  background: #f0f3fa !important;
}
.router-tab__item.is-active {
  border-bottom-color: #f0f3fa !important;
}
.router-tab__item {
  font-size: 16px;
}
.router-tab__item.is-active,
.router-tab__item:hover {
  color: #4d8af9;
}
.router-tab__contextmenu-item:active,
.router-tab__contextmenu-item:hover {
  color: #4d8af9;
}
.router-tab__scrollbar {
  height: 8px !important;
}
</style>
<style scope>
#main >>> .el-menu--collapse {
  width: 64px !important;
}
/* [title="欢迎页面"] + i {
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/main.vue